// extracted by mini-css-extract-plugin
export var legendIndicator = "_g6-1";
export var legendRight = "_g6-0";